/*
line items Properties : _gwpType
  - threshold 
  - collection
  - choose_gift
  - auto
*/

document.addEventListener("customAddToCart", () => {
  const cartFunc = new CartFunc();
  cartFunc.init();
});

document.addEventListener("DOMContentLoaded", () => {
  const cartFunc = new CartFunc();
  cartFunc.init();
});

class CartFunc {
  cart = null;
  gwpSettings = window.gwpSettings || {};
  porductsToAdd = [];
  productsToRemove = [];
  GiftPopup = document.getElementById("GiftPopup");
  constructor() {
    console.log("CartFunc initialized");
  }
  async loadCart() {
    const res = await fetch("/cart.js");
    this.cart = await res.json();
    return this.cart;
  }
  async init() {
    await this.loadCart();
    this.runGiftFunctionality();
  }
  async runGiftFunctionality() {
    if (!this.cart) await this.loadCart();

    if (this.gwpSettings.GWP_Enabled) {
      // Run
      if (this.gwpSettings.GWP_Threshold_Enabled) {
        console.log("Running GWP Threshold Check");
        this.runGWP_Threshold();
      } else {
        this.remove_gifts("threshold");
      }
      if (this.gwpSettings.GWP_Auto_Enabled) {
        console.log("Running GWP Auto Check");
        this.run_gwap();
      } else {
        this.remove_gifts("auto");
      }
      if (this.gwpSettings.GWP_Collection_Enabled) {
        console.log("Running GWP Collection Check");
        this.run_gwcp();
      } else {
        this.remove_gifts("collection");
      }
      if (this.gwpSettings.GWP_Product_Enabled) {
        console.log("Running GWP Product Check");
        this.run_gwp();
      } else {
        this.remove_gifts("product");
      }
    }

    // check if we need to open the gift popup
    if (
      this.gwpSettings.GWP_enable_gift_popup &&
      this.gwpSettings.GWP_gift_popup_threshold
    ) {
      console.log("Running GWP Choose Gift Check");
      this.run_gwp_choose_gift();
    }
    if (this.porductsToAdd.length > 0) {
      console.info("Adding items to cart", this.porductsToAdd);
      await this.addItemsToCart();
    }
    if (this.productsToRemove.length > 0) {
      console.info("Removing items from cart", this.productsToRemove);
      await this.removeItemsFromCart();
    }
  }

  runGWP_Threshold() {
    // Ensure settings are valid
    const thresholds = this.gwpSettings.GWP_Thresholds || [];
    if (thresholds.length === 0) return;

    const cartTotal = this.cart.total_price / 100;
    const activeThreshold = thresholds
      .filter((tier) => cartTotal >= tier.threshold)
      .sort((a, b) => b.threshold - a.threshold)[0];

    console.log("Active GWP Threshold:", activeThreshold);
    const activeGiftIds = activeThreshold
      ? activeThreshold.gifts.map((g) => g.id)
      : [];

    if (activeThreshold) {
      activeGiftIds.forEach((giftId) => {
        const giftInCart = this.cart.items.some(
          (item) =>
            item.id === giftId && item.properties?._gwpType === "threshold"
        );

        if (!giftInCart) {
          this.porductsToAdd.push({
            id: giftId,
            quantity: 1,
            properties: {
              _gwpType: "threshold",
              _gwpThreshold: activeThreshold.threshold,
              _gwpId: Date.now(),
            },
          });
        }
      });
    }

    // 4. Remove gifts from lower tiers or from tiers not active anymore
    this.cart.items
      .filter((item) => item.properties?._gwpType === "threshold")
      .forEach((item) => {
        const giftStillValid = activeGiftIds.includes(item.id);
        if (!giftStillValid) {
          this.productsToRemove.push(item.key);
        }
      });
  }

  // REMOVE GIFTS

  remove_gifts(type) {
    this.cart.items
      .filter((item) => item.properties?._gwpType === type)
      .forEach((item) => {
        this.productsToRemove.push(item.key);
      });
  }

  run_gwap() {
    // gift with auto purchase
    // goal: if the customer has at least one real product in the cart, add the gift automatically
    // gwp_type = auto

    console.log("running gift with any purchase check");
    const giftId = this.gwpSettings.GWP_Auto_Product_gift?.id;
    if (!giftId) return; // no gift configured

    const giftInCart = this.cart.items.some(
      (item) => item.id === giftId && item.properties?._gwpType === "auto"
    );

    // Count real products (exclude gifts and giftcards)
    const hasRealProduct = this.cart.items.some(
      (item) => item.handle !== "giftcard" && !item.properties?._gwpType
    );

    if (hasRealProduct && !giftInCart) {
      // add gift
      this.porductsToAdd.push({
        id: giftId,
        quantity: 1,
        properties: {
          _gwpType: "auto",
          _gwpId: Date.now(), // unique ID
        },
      });
    }

    if (!hasRealProduct && giftInCart) {
      // remove gift if cart only has gifts or giftcards
      const giftItem = this.cart.items.find(
        (item) => item.id === giftId && item.properties?._gwpType === "auto"
      );
      if (giftItem) {
        this.productsToRemove.push(giftItem.key);
      }
    }
  }

  run_gwp() {
    // gift with purchase
    // goal : if the customer has one of the target products add the configured one automatically
    // gwp_type : product

    const targetVariants = this.gwpSettings.GWP_Product_Target.variants || []; // array of variant IDs
    const giftId = this.gwpSettings.GWP_Product_Gift?.id;
    if (!giftId || targetVariants.length === 0) return;

    // Check if any target product is in the cart
    const productInCart = this.cart.items.some((item) =>
      targetVariants.includes(item.id)
    );

    // Check if the gift is already in the cart
    const giftInCart = this.cart.items.some(
      (item) => item.id === giftId && item.properties?._gwpType === "product"
    );

    if (productInCart && !giftInCart) {
      // Add the gift
      this.porductsToAdd.push({
        id: giftId,
        quantity: 1,
        properties: {
          _gwpType: "product",
          _gwpId: Date.now(),
        },
      });
    }

    if (!productInCart && giftInCart) {
      const giftItem = this.cart.items.find(
        (item) => item.id === giftId && item.properties?._gwpType === "product"
      );
      if (giftItem) {
        this.productsToRemove.push(giftItem.key);
      }
    }
  }
  run_gwcp() {
    // gift with collection purchase
    // goal : if the customer has one of the target collection products add the configured one automatically
    // gwp_type : collection

    const targetVariants =
      this.gwpSettings.GWP_Collection_Target.variants || []; // array of variant IDs in the collection
    const giftId = this.gwpSettings.GWP_Collection_Gift?.id;
    if (!giftId || targetVariants.length === 0) return;

    // Check if any collection product is in the cart
    const productInCart = this.cart.items.some((item) =>
      targetVariants.includes(item.id)
    );

    // Check if the gift is already in the cart
    const giftInCart = this.cart.items.some(
      (item) => item.id === giftId && item.properties?._gwpType === "collection"
    );

    if (productInCart && !giftInCart) {
      // Add the gift
      this.porductsToAdd.push({
        id: giftId,
        quantity: 1,
        properties: {
          _gwpType: "collection",
          _gwpId: Date.now(),
        },
      });
    }

    if (!productInCart && giftInCart) {
      const giftItem = this.cart.items.find(
        (item) =>
          item.id === giftId && item.properties?._gwpType === "collection"
      );
      if (giftItem) {
        this.productsToRemove.push(giftItem.key);
      }
    }
  }
  run_gwp_choose_gift() {
    // gift with choose gift purchase
    // goal : if the customer has one of the target products add the configured one automatically
    // gwp_type : choose_gift

    const cartTotal = this.cart.total_price / 100;
    const threshold = this.gwpSettings.GWP_gift_popup_threshold;
    const giftOptions = this.gwpSettings.popup_gifts || [];

    const existingGift = this.cart.items.find(
      (item) => item.properties?._gwpType === "choose_gift"
    );
    // console.log('Cart total:', cartTotal, 'Threshold:', threshold, 'Existing Gift:', existingGift);

    if (cartTotal >= threshold) {
      // console.log('Eligible for choose gift options');
      // console.log('Gift options available:', giftOptions.length);
      if (!existingGift && giftOptions.length > 0) {
        // console.log('No existing gift found, opening gift popup');
        const popup = document.getElementById("GiftPopup");
        if (popup) {
          popup.openWithGifts();
        }
      } else {
        // console.log('Existing gift already in cart, no action needed');
      }
    } else {
      // console.log('Not eligible for choose gift options, removing existing gift if any');
      if (existingGift) {
        this.productsToRemove.push(existingGift.key);
      }
    }
  }

  async addItemsToCart() {
    if (this.porductsToAdd.length === 0) return;
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        items: this.porductsToAdd,
      }),
    });
    if (res.ok) {
      this.porductsToAdd = [];
      await this.loadCart();
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "cart-func",
        cartData: this.cart,
      });
    }
  }
  async removeItemsFromCart() {
    if (this.productsToRemove.length === 0) return;
    const updates = {};
    this.productsToRemove.forEach((key) => {
      updates[key] = 0;
    });
    const res = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        updates: updates,
      }),
    });
    if (res.ok) {
      this.productsToRemove = [];
      await this.loadCart();
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "cart-func",
        cartData: this.cart,
      });
    }
  }
}

class GiftPopup extends HTMLElement {
  constructor() {
    super();
    this.closeBtn = this.querySelector(".gift-popup__close");
    this.optionsWrapper = this.querySelector(".gift-popup__options");

    this.closeBtn.addEventListener("click", () => this.close());
  }

  openWithGifts() {
    this.classList.add("is-open");
  }
  close() {
    this.classList.remove("is-open");
  }
}

customElements.define("gift-popup", GiftPopup);
